import { render, staticRenderFns } from "./NewMessagePollEditor.vue?vue&type=template&id=4626e5dc&scoped=true"
import script from "./NewMessagePollEditor.vue?vue&type=script&lang=js"
export * from "./NewMessagePollEditor.vue?vue&type=script&lang=js"
import style0 from "./NewMessagePollEditor.vue?vue&type=style&index=0&id=4626e5dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4626e5dc",
  null
  
)

export default component.exports